import { useState } from "react";
import DataViewPermesisonForm from "./DataViewPermesisonForm";
import DataViewPermesisonList from "./DataViewPermesisonList";

const DataViewPermesison = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
        <DataViewPermesisonForm addForm={setFromIsShown} update={upData} />
      ) : (
        <DataViewPermesisonList addForm={setFromIsShown} update={setUpData} />
      )}
    </>
  );
};

export default DataViewPermesison;
